import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ChatNotificaties } from './conversational-chat.model';
import { KlantService } from './generated/api/klant.service';
import { AccessToken } from './generated/model/access-token';

@Injectable()
export class ConversationalChatResource {
    private readonly klantService = inject(KlantService);

    public generateToken(): Observable<AccessToken> {
        return this.klantService.generateToken({
            httpHeaderAccept: 'application/json'
        });
    }

    public deleteChatNotifications(): Observable<void> {
        return this.klantService.deleteChatNotifications();
    }

    public getChatNotifications(): Observable<ChatNotificaties> {
        return this.klantService.getChatNotifications();
    }
}
